import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimRefCode'
})
export class TrimRefCodePipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    if (value && value.length > 6) {
      return value.slice(-6);
    }
    return value;
  }

}
